module.exports = __webpack_public_path__ + "assets/location.5794e1d1.svg";